import React, { useEffect } from "react";
import { Menu } from "../../components/menu";
import Product from "../../components/menu/product";
import {
  getCategoriesAsync,
  getItemsAsync,
} from "../../redux/features/restaurants/restaurantThunks";
import { useDispatch, useSelector } from "react-redux";
import { selectBranchDetails } from "../../redux/features/restaurants/restaurantSelectors";

export const ProductDetail = () => {
  return (
    <>
      <div className="sm:flex justify-between">
        <Menu />
        <Product />
      </div>
    </>
  );
};
